import axios from "axios";
import { getToken } from "@/lib/authStorage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "A apărut o eroare. Încercați din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatRON = (n) =>
  new Intl.NumberFormat("ro-RO", { style: "currency", currency: "RON", maximumFractionDigits: 0 }).format(n || 0);

export const formatEUR = (n) =>
  new Intl.NumberFormat("ro-RO", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

const CURRENCIES = ["EUR", "RON", "USD", "HUF"];
export const formatMoney = (n, currency = "RON") => {
  const cur = CURRENCIES.includes(currency) ? currency : "RON";
  return new Intl.NumberFormat("ro-RO", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(n || 0);
};

// Display parts (main label + optional ≈EUR line) for a listing card/detail.
export const listingPriceParts = (l) => {
  if (!l) return { main: "La cerere", eur: "" };
  if (l.price_on_request) return { main: "La cerere", eur: "" };
  const cur = l.currency || "RON";
  if (l.price_min != null && l.price_max != null)
    return {
      main: `${formatMoney(l.price_min, cur)} – ${formatMoney(l.price_max, cur)}`,
      eur: l.price_eur ? `≈ ${formatEUR(l.price_eur)}` : "",
    };
  if (l.price)
    return {
      main: formatMoney(l.price, cur),
      eur: cur !== "EUR" && l.price_eur ? `≈ ${formatEUR(l.price_eur)}` : "",
    };
  return { main: "La cerere", eur: "" };
};

export const mediaUrl = (src) =>
  !src ? "" : (src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`);

// Localized title for a listing card/detail: prefers title_i18n[lng], falls back to name/title.
export const localizedName = (item, lng) => {
  if (!item) return "";
  const l = (lng || "ro").slice(0, 2);
  return (item.title_i18n && item.title_i18n[l]) || (item.name_i18n && item.name_i18n[l]) || item.name || item.title || "";
};
// Localized description.
export const localizedDesc = (item, lng) => {
  if (!item) return "";
  const l = (lng || "ro").slice(0, 2);
  return (item.description_i18n && item.description_i18n[l]) || item.description || "";
};

// Branded OXO HUB fallback for products without a photo (hosted on the shared CDN).
export const PLACEHOLDER_IMG = "https://static.prod-images.emergentagent.com/jobs/e72d023a-8e7e-4ab5-8f73-5ed9c9d54a8e/images/2a89d8755f1862f2d3ffa5721b07a7fc057d74beb35101ba4869f353213f7038.jpeg";

export async function logSearch(term) {
  const t = (term || "").trim();
  if (t.length < 2) return;
  try {
    await api.post("/search/log", { query: t });
  } catch {
    /* non-blocking */
  }
}

export default api;
